import moment from 'moment-timezone';

import LocalStorageService from 'web-app/services/local-storage';
import store from 'web-app/react/redux/store';
import * as SessionSelectors from 'web-app/react/session/selectors';
import {EXPECTED_EXPIRATION_TIMESTAMP_KEY} from 'web-app/util/access-token-helpers';

/**
 * Copied from old implementation
 */
export const shouldPerformClientSideLogout = () => {
    const now = moment();
    const expectedExpirationTimestamp = LocalStorageService.getFromLocalStorage(EXPECTED_EXPIRATION_TIMESTAMP_KEY);
    const expectedExpirationMoment = moment(expectedExpirationTimestamp);

    if (!expectedExpirationTimestamp || !canUseAutologout()) {
        return false;
    } else {
        return now.isAfter(expectedExpirationMoment);
    }
};

const canUseAutologout = () => {
    const state = store.getState();
    return SessionSelectors.isLoggedIn(state) && SessionSelectors.canUseAutologout(state);
};
